import { Injectable } from '@angular/core';
import { AuthState } from '../typings';
import { SessionService } from '@cemex-core/angular-services-v8';

export const SS_AUTH_KEY = 'token_data';

@Injectable()
export class PersistenceService {
  constructor(private sessionService: SessionService) {}

  saveAuthState(auth: AuthState) {
    sessionStorage.setItem(SS_AUTH_KEY, JSON.stringify(auth));
    sessionStorage.setItem('access_token', auth.oauth2.access_token);
    sessionStorage.setItem('jwt', auth.jwt);
    sessionStorage.setItem('country', auth.country);
    sessionStorage.setItem('user_profile', JSON.stringify(auth.profile));
    // TODO Add all the necessary keys
  }

  // TODO Implement based on upto date production presistence
  getAuthState() {
    return this.sessionService.dataSession as AuthState;
  }

  removeAuthState() {
    this.sessionService.clean();
  }
}
